import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout'
import search from '@/views/search/index'
import store from '@/views/store/index'
import category from '@/views/category/index'
import evaluate from '@/views/evaluate/index'
import index from '@/views/home/index'
import custom from '@/views/custom/index'
import login from '../views/login/login'
import orderDetail from '../views/orderDetail/index'
import shoppingTrolley from '../views/shopping-trolley/index'
import productDetail from '../views/product/productDetail'
import placeOrder from '../views/placeOrder/index'
import afterSale from '../views/afterSale/index'
import addEvaluate from '../views/addEvaluate/index'
import evaluateDetail from '../views/evaluateDetail/index'
import couponProList from '../views/couponProlist/index'
import notificationDetails from '../views/userCenter/messageCenter/notificationDetails'

// 用户中心中心
import userCenter from '../views/userCenter/userCenter'
import couponPackage from '../views/userCenter/couponPackage/couponPackage'
import myOrder from '../views/userCenter/myOrder/myOrder'
import signingAddress from '../views/userCenter/signingAddress/signingAddress'
import userInfo from '../views/userCenter/userInfo/userInfo'
import orderAfterSale from '../views/userCenter/orderAfterSale/orderAfterSale'
import changePhone from '../views/userCenter/changeInfo/changePhone'
import myEvaluate from '../views/userCenter/myEvaluate/index'
import categoryProduct from '../views/categoryProduct/index'
import rabatt from '../views/promotions/rabatt'
import spitze from '../views/promotions/spitze'
import groupBuy from '../views/promotions/groupBuy'
import browseRecords from '../views/userCenter/browseRecords/browseRecords'
import favorites from '../views/userCenter/favorites/favorites'
import message from '../views/userCenter/messageCenter/message'
import qaList from '../views/userCenter/messageCenter/qalist'
// import changePwd from '../views/userCenter/changeInfo/changePwd'
// import unbindPhone from '../views/userCenter/changeInfo/unbindPhone'

// const error = (resolve) => {
//   import('@/components/error/error').then((module) => {
//     resolve(module)
//   })
// }
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'layout',
      component: layout,
      redirect: { name: 'index' },
      children: [
        // 首页
        {
          path: '/index',
          name: 'index',
          component: index,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 自定义页面
        {
          path: '/custom',
          name: 'custom',
          component: custom,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 用户中心
        {
          path: '/userCenter',
          name: 'userCenter',
          component: userCenter,
          meta: {
            logoText: '',
            searchVisible: false
          },
          children: [
            {
              path: '/couponPackage',
              name: 'couponPackage',
              component: couponPackage,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/myOrder',
              name: 'myOrder',
              component: myOrder,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/orderAfterSale',
              name: 'orderAfterSale',
              component: orderAfterSale,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/signingAddress',
              name: 'signingAddress',
              component: signingAddress,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/userInfo',
              name: 'userInfo',
              component: userInfo,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/changePhone',
              name: 'changePhone',
              component: changePhone,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/myEvaluate',
              name: 'myEvaluate',
              component: myEvaluate,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/browseRecords',
              name: 'browseRecords',
              component: browseRecords,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/favorites',
              name: 'favorites',
              component: favorites,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/message',
              name: 'message',
              component: message,
              meta: {
                logoText: '',
                searchVisible: false
              }
            },
            {
              path: '/qaList',
              name: 'qaList',
              component: qaList,
              meta: {
                logoText: '',
                searchVisible: false
              }
            }
            // {
            //   path: '/changePwd',
            //   name: 'changePwd',
            //   component: changePwd,
            //   meta: {
            //     logoText: '',
            //     searchVisible: false
            //   }
            // },
            // {
            //   path: '/unbindPhone',
            //   name: 'unbindPhone',
            //   component: unbindPhone,
            //   meta: {
            //     logoText: '',
            //     searchVisible: false
            //   }
            // }
          ]
        },
        // 搜索
        {
          path: '/search',
          name: 'search',
          component: search,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 店铺主页
        {
          path: '/store',
          name: 'store',
          component: store,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 分类页面
        {
          path: '/category',
          name: 'category',
          component: category,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 评价
        {
          path: '/evaluate',
          name: 'evaluate',
          component: evaluate,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 购物车
        {
          path: '/shopping-trolley',
          name: 'shoppingTrolley',
          component: shoppingTrolley,
          meta: {
            logoText: '',
            searchVisible: true
          }

        },
        // 订单详情
        {
          path: '/orderDetail',
          name: 'orderDetail',
          component: orderDetail,
          meta: {
            logoText: '',
            searchVisible: true
          }

        },
        // 商品详情
        {
          path: '/productDetail',
          name: 'productDetail',
          component: productDetail,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 下单页面
        {
          path: '/placeOrder',
          name: 'placeOrder',
          component: placeOrder,
          meta: {
            logoText: '收银台',
            searchVisible: true
          }
        },
        {
          path: '/afterSale',
          name: 'afterSale',
          component: afterSale,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 评价详情
        {
          path: '/evaluateDetail',
          name: 'evaluateDetail',
          component: evaluateDetail,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 追评
        {
          path: '/addEvaluate',
          name: 'addEvaluate',
          component: addEvaluate,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 优惠券商品
        {
          path: '/couponProList',
          name: 'couponProList',
          component: couponProList,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 类别商品
        {
          path: '/categoryProduct',
          name: 'categoryProduct',
          component: categoryProduct,
          meta: {
            logoText: '',
            searchVisible: true
          }
        },
        // 折扣专区
        {
          path: '/rabatt',
          name: 'rabatt',
          component: rabatt
        },
        // 秒杀专区
        {
          path: '/spitze',
          name: 'spitze',
          component: spitze
        },
        {
          path: '/groupBuy',
          name: 'groupBuy',
          component: groupBuy
        },
        {
          path: '/notificationDetails',
          name: 'notificationDetails',
          component: notificationDetails
        }
      ]
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      component: login
    }
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  // cookie没有值就跳到登陆页
  // let area = sessionStorage.getItem('area')
  // if (area === null && to.name !== 'login' && to.name !== 'overview') {
  //   // Vue.prototype.$message.error('用户未登陆')
  //   next('/login')
  // } else {
  next()
  // }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js